import { Grid, GridItem } from "@chakra-ui/react";
import { Parts, UI } from "components";

export default function Adjusts(){
    return(
    <>
    <UI.Header title="Ajustes" />

    <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={4}>

        {/*  Security Code */}
        <GridItem><Parts.Widgets.Adjusts.SecurityCode /></GridItem>

        {/*  Notifications */}
        <GridItem><Parts.Widgets.Adjusts.Notifications /></GridItem>

        {/*  Support */}
        <GridItem><Parts.Widgets.Adjusts.Support /></GridItem>

        {/*  Performance */}
        <GridItem><Parts.Widgets.Adjusts.Cache /></GridItem>

    </Grid>
    </>
    )
}